import FieldType from './FieldType'
export class ExportField {
    ID: number;
    Header: string;
    CONAHeader?: string;
    FieldTypeID?: number;
    FieldType?: FieldType;
    FieldName?: string;
    Value?: string;
    Sequence?: number;
    EquipmentSequenceOverride?: number;
}

export default ExportField;